/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { sortByTitle } from './helpers/sortByTitle';

export const renameProductType = createAsyncThunk(
  'productTypes/rename',
  async ({ productTypeId, title, originalTitle }, {
    extra: {
      sdk, utils, localization, Toast, Logger, showDialogAsync,
    },
  }) => {
    const trimmedTitle = title.trim();
    const {
      TITLE, TEXT, OK, CANCEL,
    } = localization.DIALOGS.PRODUCT_TYPE_RENAME;

    try {
      const { promise } = showDialogAsync({
        title: TITLE(originalTitle, trimmedTitle),
        text: TEXT,
        textBtnCancel: CANCEL,
        textBtnOk: OK,
      });
      await promise;
    } catch (error) {
      /** user pressed "Cancel" */
      return { cancelled: true };
    }

    try {
      const { data } = await sdk.productTypes.update(productTypeId, { title: trimmedTitle });
      return { productType: data };
    } catch (error) {
      const subcode = utils.getDataFromResponceError(error, 'subcode');
      if (subcode === 'ProductTypeAlreadyExistsApiError') {
        Toast(localization.PRODUCT_TYPES.alreadyExists, { autoClose: 5000, type: 'error' });
        return null; /** no need to throw the error */
      }
      Logger.error(new Error('Can not rename product type'), { error }, [
        'RenameProductTypeFailed',
        { errorMessage: (error && error.message) || 'NoMessage' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(renameProductType.pending, (state, { meta }) => {
      const { productTypeId } = meta.arg;
      if (!state.processingIds.includes(productTypeId)) {
        state.processingIds.push(productTypeId);
      }
    })
    .addCase(renameProductType.fulfilled, (state, { payload, meta }) => {
      state.processingIds = state.processingIds.filter(
        (processingId) => processingId !== meta.arg.productTypeId,
      );
      if (!payload || payload.cancelled) return;
      const item = state.items.find(({ _id }) => _id === payload.productType._id);
      if (item) {
        item.title = payload.productType.title;
        state.items = sortByTitle(state.items);
      }
    })
    .addCase(renameProductType.rejected, (state, { error, meta }) => {
      state.processingIds = state.processingIds.filter(
        (processingId) => processingId !== meta.arg.productTypeId,
      );
      state.error = error;
    });
};
